const SCHEDULE_DETAILS_DAY_2 = [
    {
      id: 1,
      eventName: 'Registration',
      eventTime: '9.00 am - 10.00 am',
      description:"Join 600 product managers, designers, founders, engineers – and everything in between – to learn, eat, chat and have a great time."
    },

    {
        id: 2,
        eventName: 'Registration',
        eventTime: '10am-12pm',
        description:"Join 600 product managers, designers, founders, engineers – and everything in between – to learn, eat, chat and have a great time."
    },

    {
        id: 3,
        eventName: 'Registration',
        eventTime: '10am-12pm',
        description:"Join 600 product managers, designers, founders, engineers – and everything in between – to learn, eat, chat and have a great time."
    },

    {
        id: 4,
        eventName: 'Registration',
        eventTime: '10am-12pm',
        description:"Join 600 product managers, designers, founders, engineers – and everything in between – to learn, eat, chat and have a great time."
    },

  ];
  
  export default SCHEDULE_DETAILS_DAY_2;
  